import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import { useTheme } from "./contexts/ThemeContext";
import { FaUsers } from "react-icons/fa";

const Sidebar = ({ roleName }) => {
  const { themeStyles } = useTheme();
  const location = useLocation();
  const [submenuOpen, setSubmenuOpen] = useState(null);

  const drawerBackground = themeStyles.appBar?.background || "#173B45";

  // Menu configuration
  const menuItems = [
    // {
    //   id: "home",
    //   label: "Home",
    //   icon: "🏠",
    //   path: "/Home",
    //   subitems: null,
    // },
    {
      id: "master",
      label: "Master",
      icon: "🏢",
      subitems: [
        { label: "Company", path: "/CompanyEdit" },
        { label: "Customer", path: "/CustomerIndex" },
        { label: "Supplier", path: "/SupplierIndex" },
        { label: "Category", path: "/CategoryIndex" },
        { label: "Item", path: "/ItemIndex" },
        { label: "Account Head", path: "/IncomeExpenseHeadIndex" },
        { label: "Bank", path: "/BankIndex" },
      ],
    },
    {
      id: "transaction",
      label: "Transaction",
      icon: "💳",
      subitems: [
        { label: "Purchase", path: "/PurchaseIndex" },
        { label: "Food Register", path: "/DailyFoodRegister" },
      ],
    },
    {
      id: "invoice",
      label: "Invoice",
      icon: "📋",
      subitems: [
        { label: "Invoice List", path: "/InvoiceIndex" },
        { label: "Invoice Generate ", path: "/InvoiceGenerate" },
      ],
    },
    {
      id: "accounts",
      label: "Accounts",
      icon: "💰",
      subitems: [
        { label: "Payment & Receipt", path: "/PaymentAndReceiptIndex" },
        { label: "Income & Expense", path: "/IncomeExpenseIndex" },
      ],
    },
    // {
    //   id: "payment",
    //   label: "Payment & Receipt",
    //   icon: "📄",
    //   path: "/PaymentAndReceiptIndex",
    //   subitems: null,
    // },
    // {
    //   id: "authzen",
    //   label: "Auth Zen",
    //   icon: "👥",
    //   subitems: [
    //     { label: "Users", path: "/UserIndex" },
    //     { label: "Roles", path: "/RoleIndex" },
    //     { label: "Reset Password", path: "/PasswordChange" },
    //   ],
    // },
    {
      id: "authzen",
      label: "Auth Zen",
      icon: <FaUsers color="white" />,
      subitems: [
        { label: "Users", path: "/UserIndex" },
        { label: "Roles", path: "/RoleIndex" },
        { label: "Reset Password", path: "/PasswordChange" },
      ],
    },

    {
      id: "reports",
      label: "Reports",
      icon: "📊",
      subitems: [
        { label: "Ledger", path: "/Ledger" },
        { label: "Outstanding", path: "/Outstanding" },
        { label: "Expense Report", path: "/ExpenseReport" },
        { label: "Consignment", path: "/InvoiceReport" },
        { label: "Detailed Invoice", path: "/DetailedInvoice" },
      ],
    },
  ];

  const handleMenuClick = (item) => {
    if (item.subitems) {
      setSubmenuOpen(submenuOpen === item.id ? null : item.id);
    } else {
      setSubmenuOpen(null);
    }
  };

  const handleCloseSubmenu = () => {
    setSubmenuOpen(null);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Fixed Narrow Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 70,
          flexShrink: 0,
          display: { xs: 'none', md: 'block' },
          "& .MuiDrawer-paper": {
            width: 70,
            display: { xs: 'none', md: 'block' },
            background: drawerBackground,
            color: "white",
            overflowX: "hidden",
            borderRight: "none",
            boxShadow: "2px 0 8px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "18px" }}>
            M
          </Typography>
        </Box>
        <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />

        <List sx={{ mt: 2 }}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.id}
              component={item.path && !item.subitems ? NavLink : "div"}
              to={item.path || undefined}
              onClick={() => handleMenuClick(item)}
              disableRipple
              disableTouchRipple
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: 2,
                px: 1,
                minHeight: 70,
                cursor: "pointer",
                "&.active": {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #4CAF50",
                },
                ...(submenuOpen === item.id && {
                  bgcolor: "rgba(255,255,255,0.15)",
                  borderLeft: "4px solid #2196F3",
                }),
                "&:hover": {
                  bgcolor: "transparent",
                },
                "&.MuiListItemButton-root:hover": {
                  bgcolor: "transparent",
                },
              }}
            >
              <Box
                sx={{
                  fontSize: "24px",
                  mb: 0.5,
                }}
              >
                {item.icon}
              </Box>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  fontSize: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                {item.label}
              </Typography>
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      {/* Submenu Modal/Panel */}
      {submenuOpen && (
        <>
          {/* Backdrop */}
          <Box
            onClick={handleCloseSubmenu}
            sx={{
              display: { xs: 'none', md: 'block' },
              position: "fixed",
              top: 0,
              left: 70,
              right: 0,
              bottom: 0,
              bgcolor: "rgba(0,0,0,0.3)",
              zIndex: 1200,
              animation: "fadeIn 0.3s ease-in-out",
              "@keyframes fadeIn": {
                from: { opacity: 0 },
                to: { opacity: 1 },
              },
            }}
          />

          {/* Submenu Panel */}
          <Paper
            elevation={8}
            sx={{
              display: { xs: 'none', md: 'block' },
              position: "fixed",
              left: 70,
              top: 0,
              bottom: 0,
              width: 280,
              bgcolor: "white",
              zIndex: 1300,
              overflowY: "auto",
              boxShadow: "4px 0 12px rgba(0,0,0,0.2)",
              animation: "slideIn 0.3s ease-out",
              "@keyframes slideIn": {
                from: {
                  transform: "translateX(-100%)",
                  opacity: 0,
                },
                to: {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "55px",
                px: 2,
                py: 1,
                background: `linear-gradient(135deg, ${drawerBackground} 0%, #2196F3 100%)`,
                color: "white",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "15px" }}>
                {menuItems.find((item) => item.id === submenuOpen)?.label}
              </Typography>
              <IconButton onClick={handleCloseSubmenu} size="small" sx={{ color: "white", p: 0.5 }}>
                <Close fontSize="small" />
              </IconButton>
            </Box>

            <Divider />

            {/* Submenu Items */}
            <List sx={{ p: 0.5 }}>
              {menuItems
                .find((item) => item.id === submenuOpen)
                ?.subitems?.map((subitem, index) => {
                  const colors = [
                    { bg: "rgba(76, 175, 80, 0.1)", border: "#4CAF50", hover: "rgba(76, 175, 80, 0.2)" },
                    { bg: "rgba(39, 45, 51, 0.1)", border: "#2196F3", hover: "rgba(33, 150, 243, 0.2)" },
                    { bg: "rgba(255, 152, 0, 0.1)", border: "#FF9800", hover: "rgba(255, 152, 0, 0.2)" },
                    { bg: "rgba(156, 39, 176, 0.1)", border: "#9C27B0", hover: "rgba(156, 39, 176, 0.2)" },
                    { bg: "rgba(244, 67, 54, 0.1)", border: "#F44336", hover: "rgba(244, 67, 54, 0.2)" },
                    { bg: "rgba(0, 150, 136, 0.1)", border: "#009688", hover: "rgba(0, 150, 136, 0.2)" },
                    { bg: "rgba(233, 30, 99, 0.1)", border: "#E91E63", hover: "rgba(233, 30, 99, 0.2)" },
                  ];
                  const color = colors[index % colors.length];

                  return (
                    <ListItemButton
                      key={index}
                      component={NavLink}
                      to={subitem.path}
                      onClick={handleCloseSubmenu}
                      sx={{
                        borderRadius: 1,
                        mb: 0.5,
                        py: 0.8,
                        px: 1.5,
                        minHeight: "36px",
                        transition: "all 0.3s ease",
                        animation: `slideInItem 0.3s ease-out ${index * 0.05}s both`,
                        "@keyframes slideInItem": {
                          from: {
                            transform: "translateX(-20px)",
                            opacity: 0,
                          },
                          to: {
                            transform: "translateX(0)",
                            opacity: 1,
                          },
                        },
                        "&.active": {
                          bgcolor: color.bg,
                          borderLeft: `4px solid ${color.border}`,
                          fontWeight: "bold",
                          transform: "translateX(4px)",
                        },
                        "&:hover": {
                          bgcolor: color.hover,
                          transform: "translateX(8px)",
                          boxShadow: `0 2px 8px ${color.border}40`,
                        },
                      }}
                    >
                      <ListItemText
                        primary={subitem.label}
                        primaryTypographyProps={{
                          fontSize: "13px",
                          fontFamily: "monospace",
                          fontWeight: 500,
                        }}
                      />
                    </ListItemButton>
                  );
                })}
            </List>
          </Paper>
        </>
      )}
    </>
  );
};

export default Sidebar;
